import { Box } from '@mui/material';

import { ArrowDownSmallIcon } from '@setup/svg-icons/svg-icons';

import type { IconButtonProps } from '@mui/material';

export const SelectArrowDownIcon = (props: IconButtonProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '.MuiSelect-icon': {
          top: 'initial',
          width: '24px',
          height: '24px',
          mr: '2px',
        },
        svg: {
          path: {
            fill: 'currentcolor',
          },
        },
      }}
    >
      <ArrowDownSmallIcon className={props.className} />
    </Box>
  );
};
